import localFont from "next/font/local";

export const nunitoSans = localFont({
  src: [
    {
      path: "./nunito-sans-v19-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./nunito-sans-v19-latin-italic.woff2",
      weight: "400",
      style: "italic",
    },
  ],
  display: "swap",
  variable: "--font-nunito-sans",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: "Arial",
});

export const poppins = localFont({
  src: [
    {
      path: "./poppins-v24-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  display: "swap",
  variable: "--font-poppins",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: "Arial",
});

export const fonts = {
  nunitoSans,
  poppins,
};
